// Lib
import { get } from 'lodash/fp';

// Types
import type { ActionObject } from './actions/actionTypes';

export const getUserIdFromAction = (action: ActionObject): string | undefined =>
    get(['user', '_id'], action) || get('userId', action);

/** The board an action's activity is tracked against, if any. */
export const getActivityBoardId = (action: ActionObject): string | undefined => get(['activity', 'boardId'], action);

/** Whether an action opts into activity tracking (drives mention/notification derivation). */
export const isActivityTracked = (action: ActionObject): boolean => Boolean(get(['activity', 'track'], action));
